<template>
  <PageWrap page-title="Clientes">
    <b-row>
      <b-col md="8" lg="6">
        <BfInput
          v-model="searchTerm"
          data-key="key"
          label="Búsqueda"
          placeholder="Busca por código o nombre"
          suffix-icon="el-icon-search"
          @input="updateSearch"
        />
      </b-col>
    </b-row>

    <BfTable
      :columns="tableColumns"
      :data="applicants"
      border
      @row-click="tableRowClick"
      cell-class-name="tasaciones-small-cell"
    >
      <span slot="nombre" slot-scope="{row}" class="tasaciones-table-marker">{{row.nombre}}</span>
    </BfTable>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{name: 'applicant'}" tag="router-link">Nueva</BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="applicants.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          @current-change="updatePagination"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import debounce from 'lodash.debounce';
import PageWrap from '@/components/PageWrap';
import router from '@/router';
import { applicantAPI } from '@/api';

export default {
  name: 'ApplicantsList',

  data() {
    return {
      applicants: [],
      currentPage: 1,
      perPage: 15,
      searchTerm: '',
      totalRows: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const {
        data: { current_page: currentPage, data, per_page: perPage, total },
      } = await applicantAPI.getAll({
        name: this.searchTerm,
        page: this.currentPage,
        perPage: this.perPage,
      });

      this.applicants = data;
      this.totalRows = total;
      this.perPage = Number(perPage);
      this.currentPage = currentPage;
    },

    // eslint-disable-next-line func-names
    updateSearch: debounce(function() {
      this.loadData();
    }, 350),

    updatePagination(newPage) {
      this.currentPage = newPage;

      this.loadData();
    },

    tableRowClick({ row, column }) {
      if (column.property === 'nombre') {
        const { id } = row;
        router.push({ name: 'applicant', params: { id: `${id}` } });
      }
    },
  },

  computed: {
    tableColumns: () => [
      {
        label: 'Clave',
        dataKey: 'clave',
        sortable: true,
        width: 100,
      },
      {
        label: 'Nombre',
        dataKey: 'nombre',
        sortable: true,
        width: 700,
      },
      {
        label: 'Teléfono',
        dataKey: 'telefono1',
      },
      {
        label: 'Email',
        dataKey: 'email',
      },

      {
        label: 'Población',
        dataKey: 'poblacion',
        sortable: true,
      },
    ],
  },

  components: {
    PageWrap,
  },
};
</script>
